/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Aksi',
  },
  {
    name: '',
    label: 'Nama Log',
  },
  {
    name: '',
    label: 'Tipe',
  },
  {
    name: '',
    label: 'Data Baru',
  },
  {
    name: '',
    label: 'Data Lama',
  },
  {
    name: '',
    label: 'User',
  },
  {
    name: '',
    label: 'Tanggal',
  },
]

const inputs = [
  {
    name: 'log_name',
    label: 'Nama Log',
    type: 'input',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'event',
    label: 'Tipe',
    type: 'input',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'new_data',
    label: 'Data Baru',
    type: 'textarea',
    validation: {},
    col: 12,
    options: [],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
    row: 8,
  },
  {
    name: 'old_data',
    label: 'Data Lama',
    type: 'textarea',
    validation: {},
    col: 12,
    options: [],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
    row: 8,
  },
  {
    name: 'user',
    label: 'User',
    type: 'input',
    validation: {},
    col: 12,
    options: [],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
  },
  {
    name: 'updated_at',
    label: 'Tanggal',
    type: 'input',
    validation: {},
    col: 12,
    options: [],
    getItemValue: 'name',
    getItemValueId: 'value',
    additional: '',
  },
]

const LogPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getLog,
    {...query, page: pagination.page, sort_field: 'id', per_page: pagination.per_page},
    []
  )

  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Detail Log</Modal.Title>
          </Modal.Header>
          <Form>
            <Modal.Body>
              <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            </Modal.Body>
            <Modal.Footer>
              <Button className='btn btn-sm btn-secondary' onClick={toggle}>
                Batalkan
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <div style={{float: 'right', minWidth: '300px'}}>
              <Row>
                <Col md={6} />
                <Col md={6}>
                  <Form.Select
                    aria-label='Default select example'
                    className='mr-8'
                    onChange={(e) => {
                      setQuery({...query, sort_order: e.target.value})
                    }}
                  >
                    <option value='desc'>Terbaru</option>
                    <option value='asc'>Terlama</option>
                  </Form.Select>
                </Col>
              </Row>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </div>
            </div>
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={7} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={7} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>
                            <Button
                              className='btn-sm'
                              onClick={() => {
                                setFormValue({
                                  log_name: item?.log_name,
                                  event: item?.event,
                                  user: item?.user?.fullname,
                                  updated_at: new Date(item?.updated_at).toLocaleString(),
                                  properties: item?.properties,
                                  new_data: JSON.stringify(item?.properties?.attributes, null, 2),
                                  old_data: JSON.stringify(item?.properties?.old, null, 2),
                                })
                                toggle()
                              }}
                            >
                              Detail
                            </Button>
                          </td>
                          <td>{item?.log_name}</td>
                          <td>{item?.event}</td>
                          <td>
                            {item?.properties?.attributes
                              ? JSON.stringify(item?.properties?.attributes).substring(0, 30) +
                                '...'
                              : null}
                          </td>
                          <td>
                            {item?.properties?.old
                              ? JSON.stringify(item?.properties?.old).substring(0, 30) + '...'
                              : null}
                          </td>
                          <td>{item?.user?.fullname}</td>
                          <td>{new Date(item?.updated_at).toLocaleString()}</td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const Country: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Log
      </PageTitle>
      <LogPage />
    </>
  )
}

export default Country
